// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"24bbfa24","154":"658e514f","251":"408c8f10","435":"f52d52ed","453":"635f5f07","940":"dd174cbe","999":"9795947a"}[chunkId] + ".chunk.js";
};